<template>
  <div class="registryDetail">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>
      <div class="list" v-if="detailData">
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.name') }}</div>
          <div class="value">
            {{ detailData.name ? detailData.name : $t('global.unknown') }}
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.description') }}</div>
          <div class="value">
            {{
              detailData.description
                ? detailData.description
                : $t('global.unknown')
            }}
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.ipV4') }}</div>
          <div class="value">
            {{ detailData.ip_v4 ? detailData.ip_v4 : $t('global.unknown') }}
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.ipV6') }}</div>
          <div class="value">
            {{ detailData.ip_v6 ? detailData.ip_v6 : $t('global.unknown') }}
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.imagesPath') }}</div>
          <div class="value">
            {{
              detailData.images_path
                ? detailData.images_path
                : $t('global.unknown')
            }}
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.isoPath') }}</div>
          <div class="value">
            {{
              detailData.iso_path ? detailData.iso_path : $t('global.unknown')
            }}
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('registry.lastHash') }}</div>
          <div class="value">
            {{
              detailData.last_hash ? detailData.last_hash : $t('global.unknown')
            }}
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.isActive') }}</div>
          <div class="value">
            <Label
              class="text-white"
              :class="detailData.is_active ? `bg-success` : `bg-danger`"
              >{{
                $t(`global.${detailData.is_active.toString().toLowerCase()}`)
              }}</Label
            >
          </div>
        </div>
        <div class="d-flex align-items-center item">
          <div class="name">{{ $t('global.isPublic') }}</div>
          <div class="value">
            <Label
              class="text-white"
              :class="detailData.is_public ? `bg-success` : `bg-danger`"
              >{{
                $t(`global.${detailData.is_public.toString().toLowerCase()}`)
              }}</Label
            >
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'

export default {
  name: 'RegistryDetail',
  data() {
    return {
      loading: true,
      detailData: '',
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'registry.plusCloudsRegistry',
        route: '/services/registry',
      },
    ])
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      this.getDetailInfo()
        .then((res) => {
          this.setDetailInfo(res)
        })
        .catch(() => {
          this.redirectList()
        })
    },
    getDetailInfo() {
      return new Promise((resolve, reject) => {
        ApiService.get(`repo/servers/${this.$route.params.id}`)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    redirectList() {
      this.$router.push('/services/registry')
    },
    setDetailInfo(res) {
      if (res && res.data) {
        this.detailData = res.data
        this.setCustomHeaderParams()
        this.loading = false
      } else {
        this.redirectList()
      }
    },
    setCustomHeaderParams() {
      this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
        menuList: [
          {
            title: 'global.services',
          },
          {
            title: 'registry.plusCloudsRegistry',
            route: '/services/registry',
          },
          //{ title: this.$t('global.detail') },
          { title: this.detailData.name, notML: false },
        ],
        showSearch: false,
        showDetailButton: false,
      })
    },
  },
  components: {
    FullWidthList: () => import('@/components/detail/FullWidthList'),
  },
}
</script>

<style lang="scss" scoped>
.registryDetail {
  .list {
    box-sizing: border-box;
    .item {
      background: #ffffff;
      border: 1px solid #eeeff3;
      border-bottom: 1px solid #e5eaee;
      &:first-child {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
      &:last-child {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        border-bottom: 1px solid #eeeff3;
      }
      .name {
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: #b5b5c3;
        padding: 15px 20px;
        text-align: right;
        min-width: 200px;
      }
      .value {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        color: #464e5f;
        padding: 15px 20px;
      }
    }
  }
}
</style>
